import { createStore, Store, useStore as useVuexStore } from 'vuex'

import { IRootStore, IStoreType } from './type'

import login from './login/login'
import home from './home/home'
import product from './product/product'
import cache from '@/utils/cache'

const store = createStore<IRootStore>({
  state() {
    return {
      name: 'anzhiyu',
      age: 18,
      heardBarItem: '/main/home'
    }
  },
  mutations: {
    changeHeardBarItem(state, heardBarItem: string) {
      state.heardBarItem = heardBarItem
      // 防止用户刷新导致的状态丢失
      cache.setCache('heardBarItem', heardBarItem, true)
    }
  },
  actions: {
    loadLocal({ commit }) {
      const heardBarItem = cache.getCache('heardBarItem', true)
      if (heardBarItem) {
        commit('changeHeardBarItem', heardBarItem)
      }
    }
  },
  modules: {
    login,
    home,
    product
  }
})

export function setupStore() {
  store.dispatch('loadLocal')
}

// 解决Vuex中useStore类型问题(比如：子模块中的类型不能识别)
export function useStore(): Store<IStoreType> {
  return useVuexStore()
}

export default store
